import { NgIf, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { MiddlearticlesInterface } from 'src/_lib/interfaces/performance-section.interface';
import { DynamicThemeClassService } from 'src/_lib/service/dynamic-theme-class.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-subscribe-ch11',
  templateUrl: './subscribe-ch11.component.html',
  styleUrls: ['./subscribe-ch11.component.scss'],
 standalone: true,
  imports: [ReactiveFormsModule, NgIf,NgClass],
  encapsulation: ViewEncapsulation.None
})
export class SubscribeCh11Component {
  cdnImagePath = environment.cdnImagePath;
  commonImagePath: string = environment.commonImagePath;
  @Input() index9: any;
  @Input() emaildata: MiddlearticlesInterface[] = [];
  @Output() onSubmit = new EventEmitter<any>();
  @Input() emailForm: FormGroup;
  @Input() errorMessage: string = '';
  placeholder_subscribe=environment.placeholder_subscribe;

  constructor(private dynamicThemeClassService: DynamicThemeClassService) {}
  
    themeClass(divName: string): string {
      return this.dynamicThemeClassService.generateClassName(divName);
    }
}
